<template>
    <div>
        <div v-if="app_config == 'production'" class="nfc-button-wrap">
            <button v-text="buttonText" @click="ScanNFC" :class="showTandemButtonClass"></button>
            <div v-if="showTandemButton" class="tandem-button-wrap">
                <a href="/nfc/JD-OFF/tandem" class="tandem-button">Link tandem</a>
            </div>
        </div>
        <div v-if="app_config == 'local' || app_config == 'staging'" class="dummy-nfc">
            <label for="">Dummy NFC Code</label>
            <input type="text" v-model="dummyNFC">
            <button @click="submitDummyNFC">Submit</button>

            <div v-if="showTandemButton" class="tandem-button-wrap">
                <a href="/nfc/JD-OFF/tandem" class="tandem-button">Link tandem</a>
            </div>
        </div>
    </div>
    
</template>

<script>

    import { mapGetters, mapActions, mapState } from 'vuex';

    export default {
        props: ['text', 'app_config', 'action', 'show_tandem_button'],
        data() {
            return {
                buttonText: this.text,
                dummyNFC: "",
                macAddress: ""
            }
        },
        computed: {
            ...mapState([
                'discountCustomerFound',
            ]),
            showTandemButton() {
                return this.show_tandem_button
            },
            showTandemButtonClass() {
                return (this.show_tandem_button) ? 'has-tandem-button' : ''
            }
        },    
        methods: {
            ...mapActions(['searchCustomerByNFC', 'beep', 'resetNFCCustomerDetails']),
            async ScanNFC() {
                try {
                    await this.resetNFCCustomerDetails();

                    if(!this.discountCustomerFound) {
                        this.buttonText = "Scanning NFC...";

                        if(typeof FullyKiosk != "undefined") {
                            this.macAddress = fully.getMacAddress();
                            fully.nfcScanStart();
                        } else {
                            const ndef = new NDEFReader();
                            await ndef.scan();

                            ndef.addEventListener("readingerror", () => {
                                this.$swal({
                                    title: 'Error!',
                                    html: '',
                                    icon: 'error'
                                });

                                this.buttonText = this.text;
                            });

                            ndef.addEventListener("reading", async ({ serialNumber }) => {
                                this.beep();
                                await this.searchCustomerByNFC({
                                    serialNumber: serialNumber, 
                                    macAddress: this.macAddress,
                                    action: this.action
                                });
                            });
                        }
                    }
                } catch (error) {
                    this.$swal({
                        title: 'Error!',
                        html: error + ". Please contact system administrator.",
                        icon: 'error'
                    });

                    this.buttonText = this.text;
                }
            },
            async kioskNFCScan({detail}) {
                this.beep();
                await this.searchCustomerByNFC({
                    serialNumber: detail.serialNumber, 
                    macAddress: this.macAddress,
                    action: this.action
                });

                if(this.discountCustomerFound) {
                    if(typeof FullyKiosk != "undefined") {
                        fully.nfcScanStop();
                    }
                    this.buttonText = this.text;
                }
            },
            async submitDummyNFC() {
                this.beep();
                await this.searchCustomerByNFC({
                    serialNumber: this.dummyNFC, 
                    macAddress: this.macAddress,
                    action: this.action
                });
            },
        },
        mounted() {
            window.addEventListener('nfc_serial_to_vue_jump_deck_group_assign', this.kioskNFCScan)
        },
        destroyed() {
            window.removeEventListener('nfc_serial_to_vue_jump_deck_group_assign', this.kioskNFCScan, false);
        }
    }


</script>

<style lang="scss">
    .dummy-nfc {
        margin-top: 10px;
        justify-content: center;
        display: flex;
        align-items: center;

        label {
            color: #000;
            font-size: 18px;
            font-weight: 700;
            margin-right: 10px;
        }

        input {
            height: 35px;
            padding: 8px;
            width: 350px;
        }

        button {
            margin-left: 10px;
            padding: 5px;
            height: 35px;
        }

        a.tandem-button {
            background: #0059E9;
            border-radius: 18px;
            font-family: 'Montserrat';
            font-weight: 800;
            font-size: 21px;
            color: #ffffff;
            text-align: center;
            width: 100%;
            padding: 20px;
            margin-left: 50px;
            display: flex;
            justify-content: center;
            align-items: center;
            outline: none;
            border: none;
        

            &:active {
                background: #2377ff;
            }
        }
    }

    button.tandems-button {
        background: #0059E9 !important;
        font-family: 'Montserrat';
        font-weight: 800;
        font-size: 21px !important;
        color: #ffffff;
        text-align: center;
        width: 100%;
        padding: 20px;
        margin-left: 15px;
        margin-right: 15px;
        display: flex;
        justify-content: center;
        align-items: center;
        outline: none;
        border: none;
        min-height: 212px;
        border-radius: 18px !important;
    

        &:active {
            background: #2377ff !important;
        }
    }

    h2.switch-title {
        font-family: 'Montserrat';
        font-weight: 800;
        font-size: 21px;
        line-height: 25px;
        color: #181818;
        text-align: center;
        margin-bottom: 10px;
    }

    .switch-popup {
        padding: 60px 10px 95px !important;
        width: 50em !important;
    }

    .switch-actions {
        width: 100% !important;
        max-width: 800px !important;
        flex-wrap: nowrap !important;
        flex-direction: row !important;
    }

    .switch-close {
        font-family: 'Montserrat';
        font-weight: 700;
        font-size: 50px;
        color: #000;
        margin-top: -50px !important;
    }
</style>